import React, { useRef, useEffect, useState } from 'react'

import GLITTER_VIDEO_PATH from 'images/glitter.webm'

// TODO: base address

const useInteractionZone = ({ top, left, width, height }, initial_state = false) => {
	const [active, setActive] = useState(initial_state)
	const local_root_ref = useRef()

	useEffect(()=>{
//		onMouseOver={()=> setOvered(true)}
//		onMouseOut={()=> setOvered(false)}
	})

	const interaction_zone = (
		<span
			ref={local_root_ref}
			className={`
				block absolute
				interaction-zone
				cursor-pointer
				${active ? 'interaction-zone-active' : 'interaction-zone-inactive'}
			`}
			style={{
				top: `${top}px`,
				left: `${left}px`,
				width:`${width}px`,
				height:`${height}px`,
				zIndex: 5
			}}

			onClick={()=> setActive(active ? false : true)}
		></span>
	)

	return [active, setActive, interaction_zone]
}

export default useInteractionZone